<template>
  <div class="home">
    <div v-if="indicators && showMissingIndicators" class="warning-container">
        <h1 class="ui header">
            <i class="orange warning sign icon"></i>
            Indicadores pendientes
        </h1>

        <div v-for="(group, groupName) in indicators" :key="groupName">
            <sui-table compact="very" fixed>
                <sui-table-header>
                    <sui-table-row>
                        <sui-table-header-cell colspan="4" class="txtc">
                            {{ groupNames[groupName] }}
                        </sui-table-header-cell>
                    </sui-table-row>
                    <sui-table-row>
                        <sui-table-header-cell class="txtc" width="4">Fecha</sui-table-header-cell>
                        <sui-table-header-cell class="txtc" width="4">Estado</sui-table-header-cell>
                        <sui-table-header-cell class="txtc" width="4">Indicador</sui-table-header-cell>
                        <sui-table-header-cell class="txtc" width="4">Valor</sui-table-header-cell>
                    </sui-table-row>
                </sui-table-header>

                <sui-table-body>
                    <sui-table-row v-for="(indicator, indicatorName) in group" :key="indicatorName">
                        <sui-table-cell class="txtc" width="4">
                            {{ indicator.date }}
                        </sui-table-cell>

                        <sui-table-cell class="txtc" width="4">
                            <i :class="indicator.exists ? 'green check circle icon' : 'red times circle icon'"></i>
                        </sui-table-cell>

                        <sui-table-cell class="txtc" width="4">
                            {{ indicatorNames[indicatorName] || indicatorName }}
                        </sui-table-cell>

                        <sui-table-cell class="txtc" width="4">
                            {{ indicator.exists ? indicator.value : '-' }}
                        </sui-table-cell>
                    </sui-table-row>
                </sui-table-body>
            </sui-table>
        </div>
    </div>

    <img
      v-else
      src="@/assets/blu.png"
      class="logo"
    />
  </div>
</template>

<script>
// @ is an alias to /src
import ApiService from '@/services/ApiService'

export default {
    name: 'home',
    components: {},

    data () {
        return {
            showMissingIndicators: false,
            indicators: [],
            groupNames: {
                sofrai: 'SOFRAI',
                tiiesFondeo: 'TIIE Fondeo',
                tiiesAvg: 'TIIE Promedio'
            },
            indicatorNames: {
                SOFRAI030: 'SOFRAI 30',
                SOFRAI090: 'SOFRAI 90',
                SOFRAI180: 'SOFRAI 180',

                tiie28Fondeo: 'TIIE 28 Fondeo',
                tiie91Fondeo: 'TIIE 91 Fondeo',
                tiie182Fondeo: 'TIIE 182 Fondeo',

                TIIE028: 'TIIE 28',
                TIIE091: 'TIIE 91',
                TIIE182: 'TIIE 182'
            }
        }
    },

    beforeMount () {
        if (!this.$store.getters.isLoggedIn) {
            window.location.replace('/login')
        }

        if (this.$store.getters.user.recoverPass) {
            window.location.replace('/changePassword')
        }
    },

    async mounted () {
        let loader
        try {
            loader = this.$loading.show()
            const response = await ApiService.validateIndicators()
            loader.hide()
            console.info(response)

            this.indicators = response

            if (this.hasMissingIndicators) {
                this.$swal(
                    'Tasas incompletas',
                    'Hay tasas que no se han cargado en el sistema.',
                    'error'
                ).then(() => {
                    this.showMissingIndicators = true
                })
            }
        } catch (error) {
            loader.hide()
            this.$swal(
                'Error',
                'No se pudieron consultar las tasas, contacta al administrador',
                'error'
            )
        }
    },

    computed: {
        hasMissingIndicators () {
            if (!this.indicators) return false

            return Object.values(this.indicators).some(group =>
                Object.values(group).some(indicator => !indicator.exists)
            )
        }
    }
}
</script>

<style>
.home {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 85vh;
  text-align: center;
}

.txtc {
  text-align: center !important;
}

.logo {
  width: 25%;
}

.warning-container {
    width: 50%;
    max-width: 50%;
    margin: auto;
}

.ui.compact.table {
    margin-top: .5rem !important;
    margin-bottom: 1rem !important;
}
</style>
